'use client';

import { useEffect } from 'react';

import { SearchFilterParamKey } from '@/app/(main)/(pages)/busca/[slug]/_consts/search-filter-params.const';
import { getDiscardedDateFilterKeys } from '@/app/(main)/(pages)/busca/[slug]/_utils/filter-date.util';
import { useSearchParams } from '@/hooks/use-search-params.hook';

export function useSanitizeDateFilterParams(): void {
  const { getParam, removeParams } = useSearchParams();

  useEffect(() => {
    const discarded = getDiscardedDateFilterKeys({
      minDate: getParam(SearchFilterParamKey.minDate) ?? undefined,
      maxDate: getParam(SearchFilterParamKey.maxDate) ?? undefined,
    });

    if (!discarded.length) {
      return;
    }

    removeParams(discarded.map((key) => SearchFilterParamKey[key]));
  }, [getParam, removeParams]);
}
